import React, { useState } from 'react';
import CodeEditor from '@uiw/react-textarea-code-editor';

export default function AntibodyComplexPredictionModule({ onSubmit }) {
  const [method, setMethod] = useState('tfold');
  const [heavySeq, setHeavySeq] = useState('');
  const [lightSeq, setLightSeq] = useState('');
  const [antigenSeq, setAntigenSeq] = useState('');
  const [busy, setBusy] = useState(false);

  const extractAASeq = (seq) =>
    seq
      .split('\n')
      .filter(line => !line.startsWith('>'))
      .join('')
      .toUpperCase();

  const isValidAA = (seq) => /^[ACDEFGHIKLMNPQRSTVWY]*$/i.test(seq);

  const handleSubmit = async () => {
    const h = extractAASeq(heavySeq.trim());
    const l = extractAASeq(lightSeq.trim());
    const a = extractAASeq(antigenSeq.trim());

    if (!h || !l || !a) return alert('请填写所有序列（重链、轻链、抗原）');
    if (!isValidAA(h) || !isValidAA(l) || !isValidAA(a)) return alert('序列中包含非法字符，请检查输入');

    const form = new FormData();
    form.append('heavySeq', h);
    form.append('lightSeq', l);
    form.append('antigenSeq', a);
    form.append('method', method);

    try {
      setBusy(true);
      await onSubmit('抗体-抗原复合物预测', form, 'abcomplex');
    } catch (err) {
      alert('提交失败，请稍后重试');
      console.error(err);
    } finally {
      setBusy(false);
    }
  };

  const handlePaste = (e, setter) => {
    e.preventDefault();
    const text = e.clipboardData.getData('text/plain');
    const normalized = text.replace(/\r\n|\r|\n/g, '\n');
    setter(normalized);
  };

  return (
    <>
      {/* 方法选择 */}
      <label htmlFor="predMethod" className="font-semibold">预测方法</label>
      <select
        id="predMethod"
        className="form-select mt-1"
        value={method}
        onChange={e => setMethod(e.target.value)}
      >
        <option value="tfold">tFold</option>
        <option value="af3">AlphaFold 3</option>
        <option value="afm">AF‑Multimer</option>
      </select>

      {/* 重链序列 */}
      <label className="font-semibold pt-2">重链序列 (FASTA 或 AA)</label>
      <CodeEditor
        value={heavySeq}
        language="text"
        placeholder={``}
        onChange={(e) => setHeavySeq(e.target.value)}
        onPaste={(e) => handlePaste(e, setHeavySeq)}
        padding={12}
        minHeight={30}
        style={{
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, monospace',
          fontSize: 14,
          backgroundColor: '#f8f8f8',
          borderRadius: 8,
          border: '1px solid #ccc',
        }}
      />

      {/* 轻链序列 */}
      <label className="font-semibold pt-2">轻链序列 (FASTA 或 AA)</label>
      <CodeEditor
        value={lightSeq}
        language="text"
        placeholder={``}
        onChange={(e) => setLightSeq(e.target.value)}
        onPaste={(e) => handlePaste(e, setLightSeq)}
        padding={12}
        minHeight={30}
        style={{
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, monospace',
          fontSize: 14,
          backgroundColor: '#f8f8f8',
          borderRadius: 8,
          border: '1px solid #ccc',
        }}
      />

      {/* 抗原序列 */}
      <label className="font-semibold pt-2">抗原序列 (FASTA 或 AA)</label>
      <CodeEditor
        value={antigenSeq}
        language="text"
        placeholder={``}
        onChange={(e) => setAntigenSeq(e.target.value)}
        onPaste={(e) => handlePaste(e, setAntigenSeq)}
        padding={12}
        minHeight={30}
        style={{
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, monospace',
          fontSize: 14,
          backgroundColor: '#f8f8f8',
          borderRadius: 8,
          border: '1px solid #ccc',
        }}
      />
      <small className="text-gray-500">支持FASTA格式或氨基酸序列</small>

      {/* 提交按钮 */}
      <div className="flex justify-center pt-2">
        <button
          onClick={handleSubmit}
          disabled={busy}
          className="btn-primary w-full disabled:opacity-50"
        >
          {busy ? '处理中…' : '提交任务'}
        </button>
      </div>
    </>
  );
}

